import { SBCAAS_MODERN_LABEL } from '@/constants/sbcaas';

/**
 * SRT trunk type. Trunk types carry no service-type field, so anything that
 * needs the SRT one matches on this id rather than a backend-owned name.
 *
 * Seeded with the same id in every environment, so it is safe to hardcode
 * rather than carry in config.json.
 */
export const SRT_TRUNK_TYPE_ID = '578e59fa-d1f0-4336-94b1-a375f0e730bb';

/** APITrunkCreateModel.channelType — 0 = Fixed, 1 = Dynamic. */
export const CHANNEL_TYPE_FIXED = 0;

/** APITrunkCreateModel.authType — 0 = IpReg, 1 = SipReg. */
export const AUTH_TYPE_SIP_REG = 1;

/** Channel bounds an SRT service profile itself may be set to. */
export const SRT_PROFILE_MIN_CHANNELS = 1;
export const SRT_PROFILE_MAX_CHANNELS = 100;

/**
 * Customer-facing name for the modern service's trunk type.
 *
 * The type is named "SRT" in the database, which means nothing to a customer.
 * Only the label is swapped — the saved value keeps the backend's own name.
 */
export const srtTrunkTypeName = (trunkType) =>
    trunkType?.id === SRT_TRUNK_TYPE_ID
        ? SBCAAS_MODERN_LABEL
        : (trunkType?.name ?? '');
